import { use_slice_ui } from '@/hooks/store/use_slices';
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__generation_output_type } from '@shared/dto/generation/graph_invoke/_templates/_enums/ENUM__generation_output_type';
import { FN_GENERATION_TOOL__create_map__image_edit } from '@shared/dto/generation/graph_invoke/_templates/image_edit/FN_GENERATION_TOOL__create_map__image_edit';
import { FN_GENERATION_TOOL__create_map__vision__color_map } from '@shared/dto/generation/graph_invoke/_templates/vision__color_map/FN_GENERATION_TOOL__create_map__vision__color_map';
import { FN_GENERATION_TOOL__create_map__vision__depth } from '@shared/dto/generation/graph_invoke/_templates/vision__depth/FN_GENERATION_TOOL__create_map__vision__depth';
import { FN_GENERATION_TOOL__create_map__line__canny } from '@shared/dto/generation/graph_invoke/_templates/vision__line__canny/FN_GENERATION_TOOL__create_map__line__canny';
import { MAP__tools_by_name } from '@shared/types/types';
import { useMemo } from 'react';

export function HOOK__get_tools_map() {
  const { g_tools__output_type } = use_slice_ui(['g_tools__output_type']);

  /*
   *
   */
  let memo__tools_map = useMemo(() => get_tools_map(), [g_tools__output_type]);

  /*
   * METHODS
   */
  function get_tools_map() {
    let out: MAP__tools_by_name;

    switch (g_tools__output_type) {
      case ENUM__generation_output_type.UNKNOWN:
        //do nothing
        out = new MAP__serializable();
        break;
      case ENUM__generation_output_type.IMAGE:
        out = FN_GENERATION_TOOL__create_map__image_edit();

        break;
      case ENUM__generation_output_type.IMAGE_CONTROL__CANNY:
        out = FN_GENERATION_TOOL__create_map__line__canny();
        break;
      case ENUM__generation_output_type.IMAGE_CONTROL__COLOR_MAP:
        out = FN_GENERATION_TOOL__create_map__vision__color_map();
        break;

      case ENUM__generation_output_type.IMAGE_CONTROL__DEPTH:
        out = FN_GENERATION_TOOL__create_map__vision__depth();
        break;
      default:
        not_implemented_type(g_tools__output_type);
    }

    for (let tool of out.values()) {
      tool.graph.fields__update_aliases();
    }

    /*
     *
     */

    return out;
  }

  return memo__tools_map;
}
